// extracted by mini-css-extract-plugin
export const accordion = "FAQAccordion-module--accordion--2FZLH";
export const accordionIcon = "FAQAccordion-module--accordion-icon--9Sz0x";
export const iconArea = "FAQAccordion-module--icon-area--3uTbG";
export const panel = "FAQAccordion-module--panel--2YAND";